import { EllipsisOutlined } from "@ant-design/icons"
import { ExclamationCircleOutlined } from "@ant-design/icons"
import { Dropdown, Menu, Modal } from "antd"
import React, { useMemo } from "react"
import { useNavigate } from "react-router-dom"
import { useRecoilState } from "recoil"
import { recruitsState } from "recoils/recruitsState"
import styled from "styled-components"
import {
  deleteRecuitDetail,
  switchRecuitIsPublished,
} from "usecases/firebase/functions"

import type { Recruit } from "interfaces/RecruitIF"

const StyledOuter = styled.div`
  display: block;
  width: 4rem;
  padding-right: 1rem;
  padding-left: 2rem;
`

const RedText = styled.div`
  color: #ff4d4f;
`

interface RecruitMenuProps {
  recruit: Recruit
}
const Button = ({
  recruit,
}: RecruitMenuProps & React.ComponentProps<typeof Menu>) => {
  const [recruits, setRecruits] = useRecoilState(recruitsState)
  const [modal, contextHolder] = Modal.useModal()

  const switchIsPublicLabel = useMemo(() => {
    return recruit.isPublished ? "掲載停止" : "掲載再開"
  }, [recruit.isPublished])

  const switchIsPublicMessage = useMemo(() => {
    return recruit.isPublished
      ? "掲載停止した求人は、掲載開始するまで、応募者から見えない状態になります。"
      : "掲載開始した求人は、応募者から見える状態になります。"
  }, [recruit.isPublished])

  const showSwitchIsPublished = () =>
    modal.confirm({
      title: "「" + recruit.title + "」を" + switchIsPublicLabel + "しますか？",
      onOk() {
        doSwitchIsPublished()
      },
      okText: switchIsPublicLabel + "する",
      cancelText: "キャンセル",
      zIndex: 2000,
      centered: true,
      content: <p>{switchIsPublicMessage}</p>,
    })
  const showDelete = () =>
    modal.confirm({
      title: "「" + recruit.title + "」を削除しますか？",
      onOk() {
        doDelete()
      },
      okText: "削除する",
      cancelText: "キャンセル",
      zIndex: 2000,
      centered: true,
      okButtonProps: { danger: true },
      content: <p>削除した求人は求人管理ページから完全に削除されます。</p>,
    })
  const navigate = useNavigate()

  const doEdit = () => {
    navigate("/recruit/" + recruit.recruitId + "/edit")
  }

  const doSwitchIsPublished = async () => {
    const newRecruits = recruits.map((item) => {
      if (item.recruitId === recruit.recruitId) {
        return { ...item, isPublished: !item.isPublished }
      }
      return item
    })
    await switchRecuitIsPublished(recruit.recruitId)
    setRecruits(newRecruits)
  }

  const doDelete = async () => {
    const newRecruits = recruits.filter((item) => {
      if (item.recruitId !== recruit.recruitId) return item
    })
    await deleteRecuitDetail(recruit.recruitId)
    setRecruits(newRecruits)
  }

  const menu = () => {
    return (
      <>
        <Menu>
          <Menu.Item key="edit" onClick={doEdit}>
            編集
          </Menu.Item>
          {recruit.isApproved && (
            <Menu.Item key="switch" onClick={showSwitchIsPublished}>
              {switchIsPublicLabel}
            </Menu.Item>
          )}
          <Menu.Item key="delete" onClick={showDelete}>
            <RedText>削除</RedText>
          </Menu.Item>
        </Menu>

        <Modal
          title={
            <>
              <ExclamationCircleOutlined />
              {"「" +
                recruit.title +
                "」を" +
                switchIsPublicLabel +
                "しますか？"}
            </>
          }
          onOk={doSwitchIsPublished}
          okText={switchIsPublicLabel + "する"}
          cancelText="キャンセル"
          zIndex={2000}
        >
          <p>{switchIsPublicMessage}</p>
        </Modal>
        <Modal>
          <p>削除した求人は求人管理ページから完全に削除されます。</p>
        </Modal>
        {contextHolder}
      </>
    )
  }

  return (
    <Dropdown overlay={menu} placement="bottomRight">
      <EllipsisOutlined onClick={(e) => e.preventDefault()} />
    </Dropdown>
  )
}
export const RecruitMenu = ({
  recruit,
  ...props
}: RecruitMenuProps & React.ComponentProps<typeof StyledOuter>) => {
  return (
    <StyledOuter {...props}>
      <Button recruit={recruit} />
    </StyledOuter>
  )
}
